import axios from 'axios';
/* eslint-disable newline-before-return */
/* eslint-disable camelcase */
import { ServiceTransport } from '@tencent/s2-client-vue-lib';
import { AppEnum } from '.';
import { ServiceImportAndExport } from './ServiceImportAndExport';

import ELEMENT from 'element-ui';
import { IUploadData } from '@/components/upload-attachment/interfaces/IUploadData';
import qs from 'qs';
import { ISceneMode } from '@/store/modules/ModuleApp';
import { getReportCodeById, getSourceReportId } from '@/libs/LibsReporHelper';
import { conforms } from 'lodash';

/**
 * 公用接口
 *
 * @class ServiceCommon
 * @extends {ServiceAdapter}
 */
class ServiceCommon extends ServiceImportAndExport {
	static GET_REQUEST: string = 'get';
	static POST_REQUEST: string = 'post';

	/** 首页接口 */
	public pageHeaderUrl: string = '/index/getPageHeader';

	/** constructor */
	constructor() {
		super(AppEnum.CAS_COMMON_DATA_URL);
	}

	// ============================= new store ============================
	/**
	 * 导出
	 * @param data
	 */
	public async templateDataExport(data: any = {}): Promise<any> {
		return await this.post('/grid/exportData', this.appendReportCode(data));
	}

	/**
	 * 获取当前模式场景下表单列表
	 *
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async templateDataListReport(): Promise<any> {
		return await this.get('/data/listReport');
	}

	/**
	 * 获取待办条数(订单和验收)
	 *
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async queryWorkTableCount(): Promise<any> {
		console.log('queryWorkTableCount.. DATA');

		return {
			status: 0,
			data: {
				sumCount: 146,
				orderCount: 97,
				acceptCount: 49
			},
			message: 'worktable:MPP_MPP_ORDER_TODO;MPP_MPP_ACCEPTANCE_TODO_LIST;'
		};
		// return await this.post('/data/queryWorkTableCount', {});
	}

	/**
	 * 自动完成框搜索
	 * @param data
	 */
	public async templateFieldsSearchDimension(data: any = {}): Promise<any> {
		return await this.get('/grid/getGridDimension', this.appendReportCode(data));
	}

	/**
	 * 字段导出日志
	 * @param data
	 */
	public async templateFieldsReportLog(data: any = {}): Promise<any> {
		return await this.post('/grid/getExportDataLog', this.appendReportCode(data));
	}

	/**
	 * 获取最新导出报告
	 * @param data
	 */
	public async templateGetReportLastUpdate(data: any = {}): Promise<any> {
		return await this.get('/report/getReportLastUpdate', this.appendReportCode(data));
	}

	/**
	 * 删除模板
	 * @param data
	 */
	public async templateDelete(data: any = {}): Promise<any> {
		return await this.post('/template/delete', this.appendReportCode(data));
	}

	/**
	 * 获取模板
	 * @param data
	 */
	public async templateGet(data: any = {}): Promise<any> {
		return await this.get('/template/get', this.appendReportCode(data));
	}

	/**
	 * 更新模板
	 * @param data
	 */
	public async templateAddOrUpdate(data: any = {}): Promise<any> {
		return await this.post('/template/addOrUpdate', this.appendReportCode(data));
	}
	// ============================= new store ============================

	/**
	 * 获取表格显示数据
	 * @param data
	 */
	public async templateDataSearch(data: any = {}): Promise<any> {
		return await this.post('/grid/searchData', this.appendReportCode(data));
	}

	/**
	 * 获取表格元数据
	 * @param data
	 */
	public async templateFieldsGrid(data: any = {}): Promise<any> {
		return await this.get('/grid/getGridColumns', this.appendReportCode(data));
	}

	/**
	 * 获取动态表单的查询条件
	 * 获取表单头数据
	 * @param data
	 */
	public async templateFieldsSearch(data: any = {}): Promise<any> {
		return await this.get('/grid/getGridConditions', this.appendReportCode(data));
	}

	/**
	 * 获取是否有权限
	 * @param data
	 */
	public async templateReportHasRight(data: any = {}): Promise<any> {
		// test start
		const res = { success: true, message: null, data: true };

		return res;
		// test end

		// return await this.get('/report/hasRight', data);
	}

	/**
	 * 获取报表数据
	 * @param data
	 */
	public async templateReportGet(data: any = {}): Promise<any> {
		// test start
		const res = {
			success: true,
			message: null,
			data: {
				reportId: 'PR202109000018',
				reportName: 'REQUIRE_QUERY',
				displayName: '需求查询',
				canExportExcel: false,
				polyReportSetList: null,
				polyReportStyle: null,
				polyReportSearchStyle: null,
				roleBased: false
			}
		};

		return res;
		// test end

		// return await this.get('/report/get', data);
	}

	/** 请求的数据补足reportId */
	public appendReportCode(data: any): any {
		if (data) {
			// CHANGE: 所有传入CODE再返回CODE，兼容后端无返回ID问题
			// 将原来的reportId转成reportCode
			// 将原来的reportCode新加reportId
			const paramData = Array.isArray(data) ? data[0] : data;
			const reportCode: string = paramData.reportCode ?? paramData.reportId; // 此时data.reportId存的是code
			const reportId: string = getSourceReportId(paramData.reportId);

			// 默认传reportCode
			paramData.reportCode = reportCode;
			if (reportId) {
				paramData.reportId = reportId; // 如果ID存在，重新赋值
			}
		}

		return data;
	}

	/**
	 * 获取临时签名
	 * @param data
	 */
	public async queryTempSign(data: any = {}): Promise<any> {
		return await this.post('/attachment/queryCosSign', data);
	}

	/**
	 * 根据Key下载Cos上传的附件url
	 * @param data
	 */
	public async getCosDownloadUrl(filePathName: string): Promise<any> {
		return await this.post('/attachment/getCosDownloadUrl', {}, { key: filePathName });
	}

	/**
	 * 查询汇率，当前币种相对人民币的汇率
	 *
	 * @param {string} currencyCode 当前币种
	 * @param {string} ouCode 外币币种
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async queryExchangeRatesByCurrencyCode(currencyCode: string, ouCode: string = 'CNY'): Promise<any> {
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			}
		};

		const body = qs.stringify({ currencyCode, ouCode });

		return await this.post('/baseData/queryExchangeRatesByCurrencyCode', body, config);
	}

	/**
	 * 旧的上传单个文件
	 *
	 * @param {File} file
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async uploadFile(file: any): Promise<IUploadData> {
		return new Promise((resolve: any, reject: any): any => {
			const param: FormData = new FormData();

			param.append('multipartFile', file.file);

			this.apiService
				.post('/api/file/uploadSingleFile', param, {
					headers: { 'Content-Type': 'multipart/form-data' }
				})
				.then((res: any): any => {
					if (res.status === 0) {
						const uploadData: IUploadData = {
							uploadInfo: res.data,
							uploadFile: file
						};
						resolve(uploadData);
					} else if (res && res.data && res.data.status === 0) {
						const uploadData: IUploadData = {
							uploadInfo: res.data.data,
							uploadFile: file
						};
						resolve(uploadData);
					} else {
						ELEMENT.Message.warning(res.message);
						const uploadData: IUploadData = {
							uploadInfo: {},
							uploadFile: file
						};
						resolve(uploadData);
					}
				});
		});
	}

	/** 文件预览
	 *
	 */
	public async queryFileReviewUrl(data: any): Promise<any> {
		return this.post(
			'/file/queryFileReviewUrl',
			{},
			{
				params: data
			}
		);
	}

	/** 文件下载
	 *
	 */
	public async downloadFile(fileId: any): Promise<any> {
		return this.post('/file/downloadFile', {}, { params: { fileId }, responseType: 'blob' });
	}

	/**
	 * 上传多个文件
	 *
	 * @param {File} files
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async uploadFiles(files: any): Promise<any> {
		const param: FormData = new FormData();
		files.forEach((file: any) => {
			param.append('multipartFiles', file);
		});

		return this.apiService.post('/api/file/uploadMultiFile', param, {
			headers: { 'Content-Type': 'multipart/form-data' }
		});
	}

	/**
	 * 上传单个文件
	 *
	 * @param {File} file
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async uploadSingleFiles(file: any): Promise<any> {
		const param: FormData = new FormData();

		param.append('multipartFile', file);

		return this.post('/file/uploadSingleFile', param, {
			headers: { 'Content-Type': 'multipart/form-data' }
		});
	}

	/** 删除文件 */
	public async deleteFile(fileId: any): Promise<any> {
		return this.post(
			'/file/deleteFile',
			{},
			{
				params: { fileId }
			}
		);
	}

	/**
	 * 国家地区列表查询
	 * @param {any} data
	 * @memberOf ServiceCommon
	 */
	public async getBaseRegionList(params = {}): Promise<any> {
		console.log('getBaseRegionList . DATA');

		return {
			status: 0,
			data: [
				{
					id: 211,
					regionName: '中国大陆'
				},
				{
					id: 1,
					regionName: '安道尔'
				},
				{
					id: 2,
					regionName: '阿联酋'
				},
				{
					id: 3,
					regionName: '阿富汗'
				},
				{
					id: 4,
					regionName: '安提瓜和巴布达'
				},
				{
					id: 5,
					regionName: '安圭拉'
				},
				{
					id: 6,
					regionName: '阿尔巴尼亚'
				},
				{
					id: 7,
					regionName: '亚美尼亚'
				},
				{
					id: 8,
					regionName: '安哥拉'
				},
				{
					id: 10,
					regionName: '阿根廷'
				},
				{
					id: 11,
					regionName: '美属萨摩亚'
				},
				{
					id: 12,
					regionName: '奥地利'
				},
				{
					id: 13,
					regionName: '澳大利亚'
				},
				{
					id: 14,
					regionName: '阿鲁巴'
				},
				{
					id: 15,
					regionName: '奥兰群岛'
				},
				{
					id: 16,
					regionName: '阿塞拜疆'
				},
				{
					id: 17,
					regionName: '波黑'
				},
				{
					id: 18,
					regionName: '巴巴多斯'
				},
				{
					id: 19,
					regionName: '孟加拉'
				},
				{
					id: 20,
					regionName: '比利时'
				},
				{
					id: 21,
					regionName: '布基纳法索'
				},
				{
					id: 22,
					regionName: '保加利亚'
				},
				{
					id: 23,
					regionName: '巴林'
				},
				{
					id: 24,
					regionName: '布隆迪'
				},
				{
					id: 25,
					regionName: '贝宁'
				},
				{
					id: 26,
					regionName: '圣巴泰勒米岛'
				},
				{
					id: 27,
					regionName: '百慕大'
				},
				{
					id: 28,
					regionName: '文莱'
				},
				{
					id: 29,
					regionName: '玻利维亚'
				},
				{
					id: 30,
					regionName: '荷兰加勒比区'
				},
				{
					id: 31,
					regionName: '巴西'
				},
				{
					id: 32,
					regionName: '巴哈马'
				},
				{
					id: 33,
					regionName: '不丹'
				},
				{
					id: 34,
					regionName: '布韦岛'
				},
				{
					id: 35,
					regionName: '博茨瓦纳'
				},
				{
					id: 36,
					regionName: '白俄罗斯'
				},
				{
					id: 37,
					regionName: '伯利兹'
				},
				{
					id: 38,
					regionName: '加拿大'
				},
				{
					id: 39,
					regionName: '科科斯群岛'
				},
				{
					id: 40,
					regionName: '中非'
				},
				{
					id: 41,
					regionName: '瑞士'
				},
				{
					id: 42,
					regionName: '智利'
				},
				{
					id: 43,
					regionName: '喀麦隆'
				},
				{
					id: 44,
					regionName: '哥伦比亚'
				},
				{
					id: 45,
					regionName: '哥斯达黎加'
				},
				{
					id: 46,
					regionName: '古巴'
				},
				{
					id: 47,
					regionName: '佛得角'
				},
				{
					id: 48,
					regionName: '圣诞岛'
				},
				{
					id: 49,
					regionName: '塞浦路斯'
				},
				{
					id: 50,
					regionName: '捷克'
				},
				{
					id: 51,
					regionName: '德国'
				},
				{
					id: 52,
					regionName: '吉布提'
				},
				{
					id: 53,
					regionName: '丹麦'
				},
				{
					id: 54,
					regionName: '多米尼克'
				},
				{
					id: 55,
					regionName: '多米尼加'
				},
				{
					id: 56,
					regionName: '阿尔及利亚'
				},
				{
					id: 57,
					regionName: '厄瓜多尔'
				},
				{
					id: 58,
					regionName: '爱沙尼亚'
				},
				{
					id: 59,
					regionName: '埃及'
				},
				{
					id: 60,
					regionName: '西撒哈拉'
				},
				{
					id: 61,
					regionName: '厄立特里亚'
				},
				{
					id: 62,
					regionName: '西班牙'
				},
				{
					id: 63,
					regionName: '芬兰'
				},
				{
					id: 64,
					regionName: '斐济群岛'
				},
				{
					id: 65,
					regionName: '马尔维纳斯群岛'
				},
				{
					id: 66,
					regionName: '密克罗尼西亚联邦'
				},
				{
					id: 67,
					regionName: '法罗群岛'
				},
				{
					id: 68,
					regionName: '法国'
				},
				{
					id: 69,
					regionName: '加蓬'
				},
				{
					id: 70,
					regionName: '格林纳达'
				},
				{
					id: 71,
					regionName: '格鲁吉亚'
				},
				{
					id: 72,
					regionName: '法属圭亚那'
				},
				{
					id: 73,
					regionName: '加纳'
				},
				{
					id: 74,
					regionName: '直布罗陀'
				},
				{
					id: 75,
					regionName: '格陵兰'
				},
				{
					id: 76,
					regionName: '几内亚'
				},
				{
					id: 77,
					regionName: '瓜德罗普'
				},
				{
					id: 78,
					regionName: '赤道几内亚'
				},
				{
					id: 79,
					regionName: '希腊'
				},
				{
					id: 80,
					regionName: '南乔治亚岛和南桑威奇群岛'
				},
				{
					id: 81,
					regionName: '危地马拉'
				},
				{
					id: 82,
					regionName: '关岛'
				},
				{
					id: 83,
					regionName: '几内亚比绍'
				},
				{
					id: 84,
					regionName: '圭亚那'
				},
				{
					id: 85,
					regionName: '香港'
				},
				{
					id: 86,
					regionName: '赫德岛和麦克唐纳群岛'
				},
				{
					id: 87,
					regionName: '洪都拉斯'
				},
				{
					id: 88,
					regionName: '克罗地亚'
				},
				{
					id: 89,
					regionName: '海地'
				},
				{
					id: 90,
					regionName: '匈牙利'
				},
				{
					id: 91,
					regionName: '印尼'
				},
				{
					id: 92,
					regionName: '爱尔兰'
				},
				{
					id: 93,
					regionName: '以色列'
				},
				{
					id: 94,
					regionName: '马恩岛'
				},
				{
					id: 95,
					regionName: '印度'
				},
				{
					id: 96,
					regionName: '英属印度洋领地'
				},
				{
					id: 97,
					regionName: '伊拉克'
				},
				{
					id: 98,
					regionName: '伊朗'
				},
				{
					id: 99,
					regionName: '冰岛'
				},
				{
					id: 100,
					regionName: '意大利'
				},
				{
					id: 101,
					regionName: '泽西岛'
				},
				{
					id: 102,
					regionName: '牙买加'
				},
				{
					id: 103,
					regionName: '约旦'
				},
				{
					id: 104,
					regionName: '日本'
				},
				{
					id: 105,
					regionName: '柬埔寨'
				},
				{
					id: 106,
					regionName: '基里巴斯'
				},
				{
					id: 107,
					regionName: '科摩罗'
				},
				{
					id: 108,
					regionName: '科威特'
				},
				{
					id: 109,
					regionName: '开曼群岛'
				},
				{
					id: 110,
					regionName: '黎巴嫩'
				},
				{
					id: 111,
					regionName: '列支敦士登'
				},
				{
					id: 112,
					regionName: '斯里兰卡'
				},
				{
					id: 113,
					regionName: '利比里亚'
				},
				{
					id: 114,
					regionName: '莱索托'
				},
				{
					id: 115,
					regionName: '立陶宛'
				},
				{
					id: 116,
					regionName: '卢森堡'
				},
				{
					id: 117,
					regionName: '拉脱维亚'
				},
				{
					id: 118,
					regionName: '利比亚'
				},
				{
					id: 119,
					regionName: '摩洛哥'
				},
				{
					id: 120,
					regionName: '摩纳哥'
				},
				{
					id: 121,
					regionName: '摩尔多瓦'
				},
				{
					id: 122,
					regionName: '黑山'
				},
				{
					id: 123,
					regionName: '法属圣马丁'
				},
				{
					id: 124,
					regionName: '马达加斯加'
				},
				{
					id: 125,
					regionName: '马绍尔群岛'
				},
				{
					id: 126,
					regionName: '马其顿'
				},
				{
					id: 127,
					regionName: '马里'
				},
				{
					id: 128,
					regionName: '缅甸'
				},
				{
					id: 129,
					regionName: '澳门'
				},
				{
					id: 130,
					regionName: '马提尼克'
				},
				{
					id: 131,
					regionName: '毛里塔尼亚'
				},
				{
					id: 132,
					regionName: '蒙塞拉特岛'
				},
				{
					id: 133,
					regionName: '马耳他'
				},
				{
					id: 134,
					regionName: '马尔代夫'
				},
				{
					id: 135,
					regionName: '马拉维'
				},
				{
					id: 136,
					regionName: '墨西哥'
				},
				{
					id: 137,
					regionName: '马来西亚'
				},
				{
					id: 138,
					regionName: '纳米比亚'
				},
				{
					id: 139,
					regionName: '尼日尔'
				},
				{
					id: 140,
					regionName: '诺福克岛'
				},
				{
					id: 141,
					regionName: '尼日利亚'
				},
				{
					id: 142,
					regionName: '尼加拉瓜'
				},
				{
					id: 143,
					regionName: '荷兰'
				},
				{
					id: 144,
					regionName: '挪威'
				},
				{
					id: 145,
					regionName: '尼泊尔'
				},
				{
					id: 146,
					regionName: '瑙鲁'
				},
				{
					id: 147,
					regionName: '阿曼'
				},
				{
					id: 148,
					regionName: '巴拿马'
				},
				{
					id: 149,
					regionName: '秘鲁'
				},
				{
					id: 150,
					regionName: '法属波利尼西亚'
				},
				{
					id: 151,
					regionName: '巴布亚新几内亚'
				},
				{
					id: 152,
					regionName: '菲律宾'
				},
				{
					id: 153,
					regionName: '巴基斯坦'
				},
				{
					id: 154,
					regionName: '波兰'
				},
				{
					id: 155,
					regionName: '皮特凯恩群岛'
				},
				{
					id: 156,
					regionName: '波多黎各'
				},
				{
					id: 157,
					regionName: '巴勒斯坦'
				},
				{
					id: 158,
					regionName: '帕劳'
				},
				{
					id: 159,
					regionName: '巴拉圭'
				},
				{
					id: 160,
					regionName: '卡塔尔'
				},
				{
					id: 161,
					regionName: '留尼汪'
				},
				{
					id: 162,
					regionName: '罗马尼亚'
				},
				{
					id: 163,
					regionName: '塞尔维亚'
				},
				{
					id: 164,
					regionName: '俄罗斯'
				},
				{
					id: 165,
					regionName: '卢旺达'
				},
				{
					id: 166,
					regionName: '所罗门群岛'
				},
				{
					id: 167,
					regionName: '塞舌尔'
				},
				{
					id: 168,
					regionName: '苏丹'
				},
				{
					id: 169,
					regionName: '瑞典'
				},
				{
					id: 170,
					regionName: '新加坡'
				},
				{
					id: 171,
					regionName: '斯洛文尼亚'
				},
				{
					id: 172,
					regionName: '斯瓦尔巴群岛和 扬马延岛'
				},
				{
					id: 173,
					regionName: '斯洛伐克'
				},
				{
					id: 174,
					regionName: '塞拉利昂'
				},
				{
					id: 175,
					regionName: '圣马力诺'
				},
				{
					id: 176,
					regionName: '塞内加尔'
				},
				{
					id: 177,
					regionName: '索马里'
				},
				{
					id: 178,
					regionName: '苏里南'
				},
				{
					id: 179,
					regionName: '南苏丹'
				},
				{
					id: 180,
					regionName: '圣多美和普林西比'
				},
				{
					id: 181,
					regionName: '萨尔瓦多'
				},
				{
					id: 182,
					regionName: '叙利亚'
				},
				{
					id: 183,
					regionName: '斯威士兰'
				},
				{
					id: 184,
					regionName: '特克斯和凯科斯群岛'
				},
				{
					id: 185,
					regionName: '乍得'
				},
				{
					id: 186,
					regionName: '多哥'
				},
				{
					id: 187,
					regionName: '泰国'
				},
				{
					id: 188,
					regionName: '托克劳'
				},
				{
					id: 189,
					regionName: '东帝汶'
				},
				{
					id: 190,
					regionName: '突尼斯'
				},
				{
					id: 191,
					regionName: '汤加'
				},
				{
					id: 192,
					regionName: '土耳其'
				},
				{
					id: 193,
					regionName: '图瓦卢'
				},
				{
					id: 194,
					regionName: '坦桑尼亚'
				},
				{
					id: 195,
					regionName: '乌克兰'
				},
				{
					id: 196,
					regionName: '乌干达'
				},
				{
					id: 197,
					regionName: '美国'
				},
				{
					id: 198,
					regionName: '乌拉圭'
				},
				{
					id: 199,
					regionName: '梵蒂冈'
				},
				{
					id: 200,
					regionName: '委内瑞拉'
				},
				{
					id: 201,
					regionName: '英属维尔京群岛'
				},
				{
					id: 202,
					regionName: '美属维尔京群岛'
				},
				{
					id: 203,
					regionName: '越南'
				},
				{
					id: 204,
					regionName: '瓦利斯和富图纳'
				},
				{
					id: 205,
					regionName: '萨摩亚'
				},
				{
					id: 206,
					regionName: '也门'
				},
				{
					id: 207,
					regionName: '马约特'
				},
				{
					id: 208,
					regionName: '南非'
				},
				{
					id: 209,
					regionName: '赞比亚'
				},
				{
					id: 210,
					regionName: '津巴布韦'
				},
				{
					id: 212,
					regionName: '刚果（布）'
				},
				{
					id: 213,
					regionName: '刚果（金）'
				},
				{
					id: 214,
					regionName: '莫桑比克'
				},
				{
					id: 215,
					regionName: '根西岛'
				},
				{
					id: 216,
					regionName: '冈比亚'
				},
				{
					id: 217,
					regionName: '北马里亚纳群岛'
				},
				{
					id: 218,
					regionName: '埃塞俄比亚'
				},
				{
					id: 219,
					regionName: '新喀里多尼亚'
				},
				{
					id: 220,
					regionName: '瓦努阿图'
				},
				{
					id: 221,
					regionName: '法属南部领地'
				},
				{
					id: 222,
					regionName: '纽埃'
				},
				{
					id: 223,
					regionName: '美国本土外小岛屿'
				},
				{
					id: 224,
					regionName: '库克群岛'
				},
				{
					id: 225,
					regionName: '英国'
				},
				{
					id: 226,
					regionName: '特立尼达和多巴哥'
				},
				{
					id: 227,
					regionName: '圣文森特和格林纳丁斯'
				},
				{
					id: 228,
					regionName: '台湾'
				},
				{
					id: 229,
					regionName: '新西兰'
				},
				{
					id: 230,
					regionName: '沙特阿拉伯'
				},
				{
					id: 231,
					regionName: '老挝'
				},
				{
					id: 232,
					regionName: '朝鲜'
				},
				{
					id: 233,
					regionName: '韩国'
				},
				{
					id: 234,
					regionName: '葡萄牙'
				},
				{
					id: 235,
					regionName: '吉尔吉斯斯坦'
				},
				{
					id: 236,
					regionName: '哈萨克斯坦'
				},
				{
					id: 237,
					regionName: '塔吉克斯坦'
				},
				{
					id: 238,
					regionName: '土库曼斯坦'
				},
				{
					id: 239,
					regionName: '乌兹别克斯坦'
				},
				{
					id: 240,
					regionName: '圣基茨和尼维斯'
				},
				{
					id: 241,
					regionName: '圣皮埃尔和密克隆'
				},
				{
					id: 242,
					regionName: '圣赫勒拿'
				},
				{
					id: 243,
					regionName: '圣卢西亚'
				},
				{
					id: 244,
					regionName: '毛里求斯'
				},
				{
					id: 245,
					regionName: '科特迪瓦'
				},
				{
					id: 246,
					regionName: '肯尼亚'
				},
				{
					id: 247,
					regionName: '蒙古国'
				},
				{
					id: 248,
					regionName: '待定'
				}
			],
			message: null
		};
		// return await this.get('/baseRegion/query', params);
	}

	/**
	 * 查询城市
	 * @param {any} data
	 * @memberOf ServiceCommon
	 */
	public async getCityByName(params = {}): Promise<any> {
		return await this.get('/baseCity/queryCityByName', params);
	}

	/**
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async download(requestData: any): Promise<any> {
		return new Promise((resolve: any, reject: any): any => {
			this.apiService(requestData)
				.then((res: any): any => {
					if (res) {
						resolve(res);
					}
				})
				['catch']((e: any) => {
					resolve(e);
					console.log('empty', e);
				});
		});
	}

	/**
	 * 查询供应商/requireWarning/fuzzyCategoryList
	 *
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceRequirement
	 */
	public async querySupplierListByName(body: any = {}, params: any = {}): Promise<any> {
		return await this.post('/baseData/queryVendorDataByName', body, params);
	}

	/** 查询合同付款条件 */
	public async checkTheContractPaymentTerms(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			// eslint-disable-next-line no-param-reassign
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		const body = qs.stringify(data);

		return await this.post('/baseData/queryContractPaymentClauseByNo', body, config);
	}

	/**
	 * 查询模式
	 *
	 * @param {any} data
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryPartModel(data: any = {}, config: any = {}): Promise<any> {
		return await this.post('/baseData/queryPartModel', data, config);
	}

	/**
	 * 下载V2
	 *
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async downloadPostV2(method: string, url: string, data: any): Promise<any> {
		return new Promise((resolve, reject) => {
			this.apiService({
				method,
				url,
				data
			})
				.then((res: any): any => {
					resolve(res);
				})
				['catch']((e: any) => {
					console.log('downloadV2 error', e);
					resolve({ success: false, url: '' });
				});
		});
	}

	/**
	 *  download V3
	 *
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async downloadPostV3(method: string, url: string, data: any): Promise<any> {
		return new Promise((resolve: any, reject: any): any => {
			this.apiService({
				method,
				url,
				data,
				responseType: 'blob'
			})
				.then((res: any): any => {
					if (res) {
						resolve(res);
					} else {
						resolve(res);
					}
				})
				['catch']((e: any) => {
					console.log('downloadV3 error', e);
					resolve({ success: false, url: '' });
				});
		});
	}

	/** 币种模糊查询
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getCurrencyListByName(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			// eslint-disable-next-line no-param-reassign
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		const body = qs.stringify(data);

		return await this.post('/baseData/queryCurrencyListByName', body, config);
	}

	/**
	 * 币种列表查询
	 * @param {any} data
	 * @memberOf ServiceCommon
	 */
	public async getCurrencyList(params = {}): Promise<any> {
		console.log('getCurrencyList . DATA');

		return {
			status: 0,
			data: [
				{
					currencyCode: 'CNY',
					currencyName: '人民币'
				},
				{
					currencyCode: 'USD',
					currencyName: '美元'
				},
				{
					currencyCode: 'HKD',
					currencyName: '港元'
				},
				{
					currencyCode: 'AED',
					currencyName: '阿拉伯联合酋长国迪拉姆'
				},
				{
					currencyCode: 'AUD',
					currencyName: '澳元'
				},
				{
					currencyCode: 'BRL',
					currencyName: '巴西雷阿尔'
				},
				{
					currencyCode: 'CAD',
					currencyName: '加拿大元'
				},
				{
					currencyCode: 'CHF',
					currencyName: '瑞士法郎'
				},
				{
					currencyCode: 'DKK',
					currencyName: '丹麦克朗'
				},
				{
					currencyCode: 'EUR',
					currencyName: '欧元'
				},
				{
					currencyCode: 'GBP',
					currencyName: '英镑'
				},
				{
					currencyCode: 'IDR',
					currencyName: '印尼盾'
				},
				{
					currencyCode: 'INR',
					currencyName: '印度卢比'
				},
				{
					currencyCode: 'JPY',
					currencyName: '日圆'
				},
				{
					currencyCode: 'KRW',
					currencyName: '韩币'
				},
				{
					currencyCode: 'MOP',
					currencyName: '澳门元'
				},
				{
					currencyCode: 'MXN',
					currencyName: '墨西哥比索'
				},
				{
					currencyCode: 'MYR',
					currencyName: '马来西亚林吉特'
				},
				{
					currencyCode: 'NOK',
					currencyName: '挪威克朗'
				},
				{
					currencyCode: 'NZD',
					currencyName: '新西兰元'
				},
				{
					currencyCode: 'PHP',
					currencyName: '菲律宾比索'
				},
				{
					currencyCode: 'SEK',
					currencyName: '瑞典克朗'
				},
				{
					currencyCode: 'SGD',
					currencyName: '新加坡元'
				},
				{
					currencyCode: 'THB',
					currencyName: '泰铢'
				},
				{
					currencyCode: 'TWD',
					currencyName: '新台币'
				},
				{
					currencyCode: 'VND',
					currencyName: '盾'
				},
				{
					currencyCode: 'ZWL',
					currencyName: '津巴布韦元'
				},
				{
					currencyCode: 'ZAR',
					currencyName: '兰特'
				},
				{
					currencyCode: 'RUB',
					currencyName: '俄罗斯卢布'
				}
			],
			message: null
		};
		// return await this.get('/baseData/queryCurrencyList', params);
	}

	/**
	 * 查询人员列表（按人员名称模糊查询）
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getStaffListByName(data: any): Promise<any> {
		const config: any = {};
		if (data) {
			// config.headers = {
			// 	'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			// };
		}

		return await this.post('/baseData/getUsers', data, config);
	}

	/** 搜索组织架构 */
	public async getOrgs(data: any): Promise<any> {
		return await this.post('/baseData/getOrgs', data);
	}

	/** 搜索部门 */
	public async queryDepartmentList(data: any): Promise<any> {
		const config: any = {};
		if (data) {
			config.params = data;
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		return await this.get('/baseData/getDepartments', config);
	}

	/**
	 * 币种
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getStaqueryCurrencyListByNameffListByName(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryCurrencyListByName', data, config);
	}

	/**
	 * 查询供应商/requireWarning/fuzzyCategoryList
	 *
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceRequirement
	 */
	public async queryPVendorListByName(body: any = {}, params: any = {}): Promise<any> {
		return await this.post('/baseData/queryPVendorListByName', body, params);
	}

	/**
	 * 获取菜单
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async getPageHeader(): Promise<any> {
		return await this.get('/index/getPageHeader');
	}

	/** 获取权限 */
	public async getHomePageContact(): Promise<any> {
		console.log('getHomePageContact . DATA');

		return {
			status: 0,
			data: [
				{
					contactName: '需求排期接口人',
					contactUserList: [
						{
							contactUserFullName: 'v_xoyxiao(肖宇)',
							depts: ['社交增值产品部', '社交协作产品部', '综合支持中心']
						},
						{
							contactUserFullName: 'v_foxcheng(程天娇)',
							depts: ['社交用户体验设计部', '社交平台产品部', '社交平台技术部']
						}
					]
				},
				{
					contactName: '结算接口人',
					contactUserList: [
						{
							contactUserFullName: 'v_jleliang(梁嘉乐)',
							depts: ['社交用户体验设计部', '社交平台产品部', '社交平台技术部', '社交增值产品部', '社交协作产品部', '综合支持中心']
						}
					]
				},
				{
					contactName: 'PCG社交线设计外包管理负责人',
					contactUserList: [
						{
							contactUserFullName: 'xueyingli(黎雪莹)',
							depts: []
						}
					]
				}
			],
			message: null
		};
		// return await this.get('/index/getHomePageContact');
	}

	/** 设置模式和场景 */
	public async setModeAndScene(params: ISceneMode): Promise<any> {
		console.log('setModeAndScene . DATA');

		return {
			status: 0,
			data: {
				user: null,
				navMenus: [
					{
						name: '首页',
						value: '/',
						code: 'home_page',
						disabled: false,
						menus: null
					},
					{
						name: '订单管理',
						value: 'purchaseorder',
						code: 'purchase',
						disabled: false,
						menus: [
							{
								name: '订单查询',
								value: '/purchaseorder/purchaseorderQuery',
								code: 'purchase_query',
								disabled: false,
								menus: null
							},
							{
								name: '我的草稿',
								value: '/purchaseorder/purchaseorderDraft',
								code: 'purchase_draft',
								disabled: false,
								menus: null
							},
							{
								name: '我的待办',
								value: '/purchaseorder/purchaseorderApproval',
								code: 'purchase_todo',
								disabled: false,
								menus: null
							},
							{
								name: '税务台账代办',
								value: '/purchaseorder/taxAccountToBeDone',
								code: 'purchase_tax_todo',
								disabled: false,
								menus: [
									{
										name: '税务台账初审',
										value: '',
										code: 'TaxCheck',
										disabled: true,
										menus: null
									},
									{
										name: '税务台账复审',
										value: '',
										code: 'TaxProCheck',
										disabled: true,
										menus: null
									},
									{
										name: '税务台账查看',
										value: '',
										code: 'TaxAccountView',
										disabled: true,
										menus: null
									}
								]
							},
							{
								name: '需求下单/处理',
								value: '/purchaseorder/purchaseorderInquiry',
								code: 'order_inquiry',
								disabled: false,
								menus: null
							}
						]
					},
					{
						name: '验收管理',
						value: 'receiveAccept',
						code: 'acceptance',
						disabled: false,
						menus: [
							{
								name: '协同验收确认',
								value: '/receiveAccept/receiveCollaborativeConfirmation',
								code: 'receiveCollaborativeConfirmation',
								disabled: false,
								menus: null
							},
							{
								name: '业务发起验收',
								value: '/receiveAccept/receiveAcceptPending',
								code: 'receiveAcceptPending',
								disabled: false,
								menus: null
							},
							{
								name: '验收单查询',
								value: '/receiveAccept/receiveAcceptQuery',
								code: 'acceptance_query',
								disabled: false,
								menus: null
							},
							{
								name: '我的草稿',
								value: '/receiveAccept/receiveAcceptDraft',
								code: 'acceptance_draft',
								disabled: false,
								menus: null
							},
							{
								name: '我的待办',
								value: '/receiveAccept/receiveAcceptApproval',
								code: 'acceptance_todo',
								disabled: false,
								menus: null
							}
						]
					},
					{
						name: '项目管理',
						value: 'project',
						code: 'project',
						disabled: false,
						menus: [
							{
								name: '立项查询1',
								value: '/project/projectInquiry',
								code: 'projectInquiry',
								disabled: false,
								menus: null
							}
						]
					}
				],
				currentTime: '2022-03-26 15:03:06',
				dsSwitchInfo: {
					acceptanceDsQueryStatus: 'true'
				}
			},
			message: null
		};
		// return await this.post('/index/setModeAndScene', params);
	}

	/** 依据CODE获取模式和场景 */
	public async fetchModelSceneDataByCode(code: string): Promise<any> {
		return await this.get(`/index/getModeAndScene?code=${code}`);
	}

	/**
	 * 查询经办中心
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async queryCenter(params = {}): Promise<any> {
		console.log('queryceter...');

		return await this.get('/baseData/queryCenter', params);
	}

	/**
	 * 查询部门公共成本中心
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async getCostCenter(params = {}): Promise<any> {
		return await this.get('/baseData/getPublicCostCenter', params);
	}

	/**
	 * 获取个人工作台数据
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async getPersonalWorkbench(): Promise<any> {
		return await this.get('/index/getPersonalWorkbench');
	}

	/**
	 * 降级菜单显示
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async downGradeMenuUrl(): Promise<any> {
		return await this.get('/configItem/downGradeMenu');
	}

	/**
	 * 组件调用接口
	 *
	 * @param {string} url 调用接口
	 * @param {*} [data={}] data 请求参数
	 * @param {*} [config={}] ? 问号参数
	 * @param {string} [method='post'] 请求方法
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async fetchComponentData(url: string, data: any = {}, config: any = {}, method: string = ServiceCommon.POST_REQUEST): Promise<any> {
		let reauetRes: any = {};
		switch (method) {
			case ServiceCommon.POST_REQUEST:
				reauetRes = await this.post(url, data, config);
				break;
			case ServiceCommon.GET_REQUEST:
				reauetRes = await this.get(url, config);
				break;
			default:
				reauetRes = await this.post(url, data, config);
				break;
		}

		return reauetRes;
	}

	/**
	 * 查询部门(按部门名称模糊)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryDeptListByName(data: any, config: any): Promise<any> {
		// return await this.post('/baseData/queryDeptListByName', data, config);
		return await this.post('/baseData/getDeptWithPath', data, { name: config.deptName });
	}

	/**
	 * 查询部门(按部门名称模糊)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryCurrentUser(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/getCurrentUser', data, config);
	}

	/** 查询合同 */
	public async queryTheContract(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryContractsByOuCodeAndVendorId', data, config);
	}

	/** 查询我方主体 */
	public async queryOurPrincipal(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryOrganizationListByName', data, config);
	}

	/** 查询供应商 */
	public async queryTheVendor(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryVendorListByName', data, config);
	}

	/**
	 * 查询合同信息，按合同编码模糊匹配)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryContractsByNo(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryContractsByNo', data, config);
	}

	/**
	 * 查询合同明细信息，按合同编码、我方主体和供应商查询)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryContractDetailInfoByNo(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryContractDetailInfoByNo', data, config);
	}

	/**
	 * 查询框架合同信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryStructContracts(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryStructContracts', data, config);
	}

	/**
	 * 查询合同信息，我方主体，供应商id，按合同编码(非必填)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryStructContractsByOuCodeAndVendorId(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryContractsByOuCodeAndVendorId', data, config);
	}

	/** 获取所属BG列表
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceMaterial
	 */
	public async queryBgListByName(data: any, params = {}): Promise<any> {
		return await this.post('/baseData/queryBgListByName', data, params);
	}

	/**
	 * 获取默认税率列表
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceMaterial
	 */
	public async queryVats(data: any, params = {}): Promise<any> {
		return await this.post('/baseData/queryVats', data, params);
	}

	/**
	 * 物料管理 获取默认资产分类列表
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceMaterial
	 */
	public async getAssetCategory(data: any): Promise<any> {
		return await this.get('/purpose/fuzzyAssetCategory', data);
	}

	/**
	 *   查询预算科目模糊匹配
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async fuzzyAssetBudgetAccount(params = {}): Promise<any> {
		return await this.get('/purpose/fuzzyAssetBudgetAccount', params);
	}

	/**
	 * 获取业务场景列表
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceMaterial
	 */
	public async getBusinessSceneList(data: any): Promise<any> {
		return await this.get('/baseData/getBusinessSceneList', data);
	}

	/**
	 * 获取业务场景列表
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceMaterial
	 */
	public async orderConstantsQueryBrands(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryBrands', data, config);
	}

	/**
	 * 汇率模糊查询
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getExchangeRates(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryExchangeRates', data, config);
	}

	/**
	 * 从字典表获取-采购类型
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getPurchaseType(params = {}): Promise<any> {
		return await this.get('/baseData/getPurchaseType', params);
	}

	/**
	 * 询我方主体，按主体名称模糊匹配
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryOrganizationListByName(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryOrganizationListByName', data, config);
	}

	/**
	 * 决策部门模糊查询
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getDeptType(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryDeptListByName', data, config);
	}

	/**
	 * 根据id查询成本中心
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getPublicCostCenter(params = {}): Promise<any> {
		return await this.get('/baseData/getCostCenter', params);
	}

	/**
	 * 根据name查询成本中心
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getCostCenterByName(params = {}): Promise<any> {
		return await this.get('/baseData/getCostCenterByName', params);
	}

	/**
	 * 查询COA产品(按部门名称模糊)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getCOAProject(params = {}): Promise<any> {
		return await this.get('/baseData/getProduct', params);
	}

	/**
	 * 查询人员列表(按人员名称模糊)
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async queryStaffListByName(data: any, config: any): Promise<any> {
		if (config && config.staffTypes?.length) {
			data = qs.stringify(config).replace(/%5B\d%5D/g, '');
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		return await this.post('/baseData/queryStaffListByName', data, config);
	}

	/**
	 * 查询汇率，当前币种相对人民币的汇率
	 *
	 * @param {string} currencyCode 当前币种
	 * @param {string} ouCode 外币币种
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async queryVendorSiteById(vendorId: string): Promise<any> {
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			}
		};

		const body = qs.stringify({ vendorId });

		return await this.post('/baseData/queryVendorSiteById', body, config);
	}

	/**
	 * 查询正式订单供应商/requireWarning/fuzzyCategoryList
	 *
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceRequirement
	 */
	public async queryVendorDataByName(body: any = {}, params: any = {}): Promise<any> {
		return await this.post('/baseData/queryVendorDataByName', body, params);
	}

	/**
	 * 需求待审批初始化条件
	 *
	 * @param {any} data
	 * @param {any} [config={}]
	 *
	 * @memberOf ServiceMaterial
	 */
	public async queryVendorListByName(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryVendorListByName', data, config);
	}

	/**
	 * 仓库、机房模糊查询
	 *
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceRequirement
	 */
	public async getTaxRate(params = {}): Promise<any> {
		return await this.get('/baseData/getTaxRate', params);
	}

	/** 获取业务总监
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async getListBusinessDirector(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/getCenterChargerByCcId', data, config);
	}

	/**
	 * 获取授权使用对象
	 *
	 * @returns
	 *
	 * @memberOf ServiceCommon
	 */
	public async getQueryOrgList(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/baseData/queryOrgListV2', body, config);
	}

	/**
	 * 查询经办部门、经办中心、经办小组
	 * @param {*} data
	 * {
	 *      typeId ： 1:表示经办部门，2：经办小组，7：经办中心
	 *      parentId: 上层id
	 *      name:名称
	 * }
	 */
	public async getQueryOrgListV3(data: any): Promise<any> {
		return await this.post('/baseData/queryOrgListV3', {}, data);
	}

	/** 根据模式和创建查询预算科目 */
	public async queryBudgetAccountByModelAndScene(): Promise<any> {
		return await this.get('/purpose/queryBudgetAccountByModelAndScene');
	}

	/**
	 * 系统设置 获取默认核算科目
	 *
	 * @param {any} data
	 *
	 * @memberof ServiceSystem
	 */
	public async getInCheckAccount(data: any): Promise<any> {
		return await this.get('/purpose/fuzzyInCheckAccount', data);
	}

	/**
	 * 导出
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async listExport(url: string, data: any): Promise<any> {
		return await this.post(url, data);
	}

	/**
	 * 查看导出列表
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async exportTaskList(url: string, data: any): Promise<any> {
		return await this.post(url, data);
	}

	/**
	 * 查询数据导出结果
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async exportGetResult(url: string, data: any): Promise<any> {
		return await this.get(url, data);
	}

	/**
	 * 重试
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async exportRetry(url: string, data: any): Promise<any> {
		return await this.post(url, data);
	}

	/**
	 * 字典列表配置查询
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async selectList(data: any, config = {}): Promise<any> {
		return await this.post('/common/dictionary/selectList', data, config);
	}

	/** 查询项目下的资源类型 */
	public async getResourceListByProjectCode(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/mbaBaseData/getResourceListByProjectCode', body, config);
	}

	/** 查询资源类型下的场景 */
	public async getSceneListByResourceCode(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/mbaBaseData/getSceneListByResourceCode', body, config);
	}

	/** 查询采购类别 */
	public async getPurchaseTypeList(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/mbaBaseData/getPurchaseTypeList', body, config);
	}

	/** 查询资源类型下的物料编码 */
	public async batchQueryMBAMaterialByResourceCode(data: any, params: any): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post(`/mbaBaseData/batchQueryMBAMaterialByResourceCode?${params}`, body);
	}

	/** 根据部门和采购类型判断是否需要招标方案 */
	public async checkNeedSmsBid(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/mbaBaseData/checkNeedSmsBid', body, config);
	}

	/** 查询项目 */
	public async getErpProjectList(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/mbaBaseData/getErpProjectList', body, config);
	}

	/** 查询经办小组 */
	public async queryGroupList(data: any, config = {}): Promise<any> {
		const body = qs.stringify({ ...data });

		return await this.post('/baseData/queryGroupList', body, config);
	}

	// ============================= IEG ============================
	/** 附件上传至jarvis，指定appid和source */
	public async attachmentUploadWithSource(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		// const body = qs.stringify(data);

		return await this.post('/attachment/uploadWithSource', data, config);
	}

	/** 查询供应商地址账号信息 */
	public async queryVendorSiteByIdAndBgId(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		const body = qs.stringify(data);

		return await this.post('/baseData/queryVendorSiteByIdAndBgId', body, config);
	}

	/** 采购类别+经办中心来配置默认的相关审批人 */
	public async queryConfigRelateApprover(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		const body = qs.stringify(data);

		return await this.post('/baseData/queryConfigRelateApprover', body, config);
	}

	/** MBA_模糊查询物料类别 */
	public async fuzzyQueryCategoryByName(data: any, config = {}): Promise<any> {
		const body = qs.stringify(data);

		return await this.post('/mbaBaseData/fuzzyQueryCategoryByName', body, config);
	}

	/**
	 * 查询财务信息关联订单执行信息
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @return {*}  {Promise<any>}
	 * @memberof ServiceReceiveAccept
	 */
	public async batchQueryMaterialByCode(data: any, config = {}): Promise<any> {
		return await this.post('/mbaBaseData/batchQueryMaterialByCode', data, config);
	}

	/**
	 * 查询供应商选择方法
	 *
	 * @param {*} data
	 * @param {*} [config={}]
	 * @return {*}  {Promise<any>}
	 * @memberof ServiceReceiveAccept
	 */
	public async querySupplierOptTypeList(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/querySupplierOptTypeList', data, config);
	}

	/**
	 * 获取需求等级
	 *
	 * @param {*} [params={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceRequirement
	 */
	public async getRequireLevels(data: any, config = {}): Promise<any> {
		return await this.post('/require/getRequireLevels', data, config);
	}

	/**
	 * 内部型号远程搜索
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async queryInternalModels(data: any, config = {}): Promise<any> {
		return await this.post('/baseData/queryInternalModels', data, config);
	}

	/**
	 * 按钮权限数据
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async getAuthorizeInfo(data: any, config = {}): Promise<any> {
		return await this.post('/common/getAuthorizeInfo', data, config);
	}

	/**
	 * 根据平台获取bg数据
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async gePlatformBy(config = {}): Promise<any> {
		return await this.get('/common/gePlatformBy', config);
	}

	/**
	 * 附件上传
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async CASuploadFile(data: any, config = { headers: {} }): Promise<any> {
		if (config) {
			// eslint-disable-next-line no-param-reassign
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		return await this.post('/attachment/uploadFile', data, config);
	}

	/**
	 * 批量删除提交
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async batchApplyConfirm(data: any, config = {}): Promise<any> {
		return await this.post('/apply/batchApplyConfirm', data, config);
	}

	/**
	 * 模型
	 *
	 * @param {*} data
	 * @param {any} [config={}]
	 * @returns {Promise<any>}
	 *
	 * @memberOf ServiceCommon
	 */
	public async geModelByPlatform(data: any): Promise<any> {
		return await this.get('/common/geModelByPlatform', data);
	}
}

export default new ServiceCommon();
